import { DEFAULT_API_PAGE_SIZE } from '@shared/api/api.constants';

export const AG_GRID_CONFIG = {
  MAX_BLOCKS_IN_CACHE: 10,
  CACHE_OVERFLOW_SIZE: 2,
  BLOCK_LOAD_DEBOUNCE_MILLIS: 250,
  MAX_CONCURRENT_DATASOURCE_REQUESTS: 2,
  CLIENT_SIDE_PAGE_SIZES: [20, 50, 100] as number[],
  DEFAULT_CELL_PADDING: 8,
  OVERLAY_DELAY_MS: 10,
  MANUAL_OVERLAY_DELAY_MS: 300,
  SSRM_ROW_BUFFER: 10,
  CSRM_ROW_BUFFER: 20,
  CSRM_DEFAULT_PAGINATION_PAGE_SIZE: 50,
  SSRM_DEFAULT_PAGINATION_PAGE_SIZE: DEFAULT_API_PAGE_SIZE,
} as const;
